export class Logprotokoll{
    zeitstempel: Date;
    datum: string;
    aktion: string;
    text: string;
    ip: string;
    browser: string;
    benutzer: string;
}